<page-header title="REPORTS"></page-header>
<card>
  <ul>
    <li>
      <a
        [routerLink]="['rdn']"
        [routerLinkActive]="['is-active']"
        translationEditableDirective="PROPERTY_RATES_PAYMENTS_REPORT"
      >
        {{ 'PROPERTY_RATES_PAYMENTS_REPORT' | translate }}
      </a>
    </li>
    <li>
      <a
        [routerLink]="['commercial-license']"
        [routerLinkActive]="['is-active']"
        translationEditableDirective="BUSINESS_LICENSE_PAYMENT_REPORT"
      >
        {{ 'BUSINESS_LICENSE_PAYMENT_REPORT' | translate }}
      </a>
    </li>
    <li *ngxPermissionsOnly="['REPORTS_BOOKS']">
      <a
        [routerLink]="['rate-book']"
        [routerLinkActive]="['is-active']"
        translationEditableDirective="VALUATION_AND_RATE_BOOK"
      >
        {{ 'VALUATION_AND_RATE_BOOK' | translate }}</a
      >
    </li>
    <li *ngxPermissionsOnly="['REPORTS_BOOKS']">
      <a
        [routerLink]="['business-book']"
        [routerLinkActive]="['is-active']"
        translationEditableDirective="BUSINESS_LIST_BOOK"
      >
        {{ 'BUSINESS_LIST_BOOK' | translate }}
      </a>
    </li>
    <li *ngxPermissionsOnly="['BIG_REPORTS']">
      <a
        [routerLink]="['property-rates-defaulters']"
        [routerLinkActive]="['is-active']"
        translationEditableDirective="PROPERTY_RATES_DEFAULTERS"
      >
        {{ 'PROPERTY_RATES_DEFAULTERS' | translate }}
      </a>
    </li>
    <li *ngxPermissionsOnly="['BIG_REPORTS']">
      <a
        [routerLink]="['business-licence-defaulters']"
        [routerLinkActive]="['is-active']"
        translationEditableDirective="BUSINESS_LICENCE_DEFAULTERS"
      >
        {{ 'BUSINESS_LICENCE_DEFAULTERS' | translate }}
      </a>
    </li>
  </ul>
</card>
